import { render, staticRenderFns } from "./CustomerNotifications.vue?vue&type=template&id=29eea31e&scoped=true"
import script from "./CustomerNotifications.vue?vue&type=script&lang=js"
export * from "./CustomerNotifications.vue?vue&type=script&lang=js"
import style0 from "./CustomerNotifications.vue?vue&type=style&index=0&id=29eea31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eea31e",
  null
  
)

export default component.exports